import moment from 'moment/moment';

class SellYourSoul extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let formValidated = [];

    const postForm = (klaviyoData) => {
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST', // or 'PUT'
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        body: klaviyoData,
      })
        .then((response) => response.json())
        .then((data) => {
          // if (window.Shopify.customerPrivacy.marketingAllowed()) {
          //   amzn('trackEvent', 'Signup');
          // }
          let market =
            this.getAttribute('data-market') !== '/'
              ? this.getAttribute('data-market')
              : '';
          window.location.href =
            market +
            '/pages/soul-contract?name=' +
            this.querySelector('#full_name').value +
            '&email=' +
            encodeURIComponent(this.querySelector('#email').value) +
            '&date=' +
            encodeURIComponent(moment().format('MMMM DD YYYY'));
        })
        .catch((error) => {
          alert(error);
        });
    };

    if (this.querySelector('.form-submit')) {
      this.querySelector('.form-submit').addEventListener('click', (e) => {
        e.preventDefault();

        const data = {
          g: this.getAttribute('list-id'),
          $fields: 'event, shopify_tags, $accepts_marketing',
          event: this.getAttribute('event'),
          shopify_tags: this.getAttribute('shopify_tags'),
          $accepts_marketing: true,
        };

        this.querySelectorAll('.form-field').forEach((e, index) => {
          const key = e.id.replace(/-/g, '_');
          const value = e.value;
          data.$fields += `, ${key}`;
          data[key] = value;
        });

        const urlData = new URLSearchParams(data);

        this.querySelectorAll('input').forEach((e, index) => {
          if (e.reportValidity() == false) {
            formValidated[index] = false;
          } else {
            formValidated[index] = true;
          }
        });

        let checker = (arr) => arr.every(Boolean);
        if (checker(formValidated) == false) {
        } else {
          postForm(urlData);
        }
      });
    }
  }
}

customElements.define('sell-your-soul', SellYourSoul);
